import { render, staticRenderFns } from "./MoulageEffect.vue?vue&type=template&id=cc0bec5c&scoped=true&"
import script from "./MoulageEffect.vue?vue&type=script&lang=js&"
export * from "./MoulageEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0bec5c",
  null
  
)

export default component.exports